export default __webpack_public_path__ + "static/about-9aa06053d401abaa715c3f7f1d2e8795.mp4";